document.addEventListener("DOMContentLoaded", () => {
  const swiperElements = document.querySelectorAll(".swiper:not(.custom-swiper)");

  swiperElements.forEach((el) => {
    // Avoid duplicate init
    if (el.swiper) return;

    new Swiper(el, {
      // Default global config (can be overridden per section)
      slidesPerView: 1,
      spaceBetween: 32,
      loop: true,
      pagination: {
        el: el.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        750: { slidesPerView: 2 },
        990: { slidesPerView: 3 },
      }
    });
  });

  // var packagingSlider = new Swiper('.product-packaging__slider', {
  //   slidesPerView: 'auto',
  //   spaceBetween: 32,
  //   loop: true,
  //   breakpoints: {
  //     576: {
  //         slidesPerView:2,
  //         spaceBetween: 20,
  //     },
  //     768: {
  //       slidesPerView: 3
  //     }
  //   }
  // });
});